import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const CloseIconSmall: React.FC<IconProps> = (props) => (
  <IconWrapper size="small" {...props}>
    <path d="M8.00011 6.9375L3.04 2L2 3.06L6.93945 7.99816L2 12.96L3.04 14L8.00011 9.05882L12.96 14L14 12.96L9.06077 7.99816L14 3.04L12.96 2L8.00011 6.9375Z" />
  </IconWrapper>
)

export default CloseIconSmall
